export const translations = {
  english: {
    // Language Page
    selectLanguage: 'Select Your Language',
    english: 'English',
    hindi: 'हिन्दी',
    
    // Common
    home: 'Home',
    aboutUs: 'About Us',
    about: 'About',
    contact: 'Contact',
    contactUs: 'Contact Us',
    services: 'Services',
    pricing: 'Pricing',
    dashboard: 'Dashboard',
    settings: 'Settings',
    profile: 'Profile',
    logout: 'Logout',
    login: 'Login',
    signIn: 'Sign In',
    signup: 'Sign Up',
    gallery: 'Gallery',
    faqs: 'FAQs',
    forgotPassword: 'Forgot Password?',
    resetPassword: 'Reset Password',
    updatePassword: 'Update Password',
    // Need / Help Center
    needHelp: 'Need Help?',
    needHelpIntro: 'Find answers, contact support, or request a custom plan.',
    contactSupport: 'Contact Support',
    contactSupportDesc: 'Reach out to our support team for technical help.',
    guides: 'Tutorials & Guides',
    guidesDesc: 'Step-by-step tutorials to help you get started.',
    feedback: 'Feedback',
    feedbackDesc: 'Share your ideas and help us improve.',
    quickResources: 'Quick Resources',
    gettingStarted: 'Getting started guide',
    seoChecklist: 'SEO checklist',
    reportIssue: 'Report an issue',
    messageSent: 'Thanks — your message has been sent!',
    name: 'Name',
    email: 'Email',
    message: 'Message',
    supportPhone: '+1 (555) 123-4567',
    responseTime: 'Typical response within 24 hours',
    
    // Dashboard
    welcome: 'Welcome',
    accountInfo: 'Account Information',
    preferences: 'Preferences',
    integrations: 'Integrations',
    notifications: 'Notifications',
    billing: 'Billing',
    language: 'Language',
    needHelp: 'Need Help',
    reportsData: 'Reports and Data',
    // Additional UI
    managePreferences: 'Manage your account preferences',
    manage: 'Manage',
    back: 'Back',
    checkSeoHealth: 'Check your website’s SEO health and performance instantly.',
    enterWebsiteUrl: 'Enter your website URL...',
    performSeoCheck: 'Perform SEO Check',
    
    // Buttons
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add',
    confirm: 'Confirm',
    submit: 'Submit',
    previous: 'Previous',
    footer: 'Footer',
    
    // Account Information Page
    manageSubscription: 'Manage subscription, billing and connected projects',
    subscriptionBilling: 'Subscription & Billing',
    currentPlan: 'Current Plan (Lite / Standard / Advanced)',
    renewalDateBillingCycle: 'Renewal date & billing cycle',
    billingHistory: 'Billing history (invoices & receipts)',
    connectedWebsites: 'Connected Websites / Projects',
    linkedDomain: 'Linked domain / Projects',
    projectStatus: 'Project status (Active / Inactive)',
    allRightsReserved: '© 2025 NovarsisAio — All rights reserved',
  },
  hindi: {
    // Language Page
    selectLanguage: 'अपनी भाषा चुनें',
    english: 'English',
    hindi: 'हिन्दी',
    
    // Common
    home: 'होम',
    aboutUs: 'हमारे बारे में',
    about: 'परिचय',
    contact: 'संपर्क',
    contactUs: 'हमसे संपर्क करें',
    services: 'सेवाएं',
    pricing: 'मूल्य निर्धारण',
    dashboard: 'डैशबोर्ड',
    settings: 'सेटिंग्स',
    profile: 'प्रोफाइल',
    logout: 'लॉगआउट',
    login: 'लॉगिन',
    signIn: 'साइन इन',
    signup: 'साइन अप',
    gallery: 'गैलरी',
    faqs: 'अक्सर पूछे जाने वाले प्रश्न',
    forgotPassword: 'पासवर्ड भूल गए?',
    resetPassword: 'पासवर्ड रीसेट करें',
    updatePassword: 'पासवर्ड अपडेट करें',
    // Need / Help Center
    needHelp: 'मदद चाहिए?',
    needHelpIntro: 'उत्तर खोजें, समर्थन से संपर्क करें, या एक कस्टम योजना का अनुरोध करें।',
    contactSupport: 'समर्थन से संपर्क करें',
    contactSupportDesc: 'तकनीकी सहायता के लिए हमारी सपोर्ट टीम से संपर्क करें।',
    guides: 'ट्यूटोरियल और गाइड',
    guidesDesc: 'शुरू करने में मदद के लिए चरण-दर-चरण ट्यूटोरियल।',
    feedback: 'प्रतिपुष्टि',
    feedbackDesc: 'अपने विचार साझा करें और हमें सुधारने में मदद करें।',
    quickResources: 'त्वरित संसाधन',
    gettingStarted: 'शुरू करने के लिए गाइड',
    seoChecklist: 'SEO चेकलिस्ट',
    reportIssue: 'समस्या रिपोर्ट करें',
    messageSent: 'धन्यवाद — आपका संदेश भेज दिया गया है!',
    name: 'नाम',
    email: 'ईमेल',
    message: 'संदेश',
    supportPhone: '+1 (555) 123-4567',
    responseTime: 'आम तौर पर 24 घंटे के भीतर प्रतिक्रिया',
    
    // Dashboard
    welcome: 'स्वागत है',
    accountInfo: 'खाता जानकारी',
    preferences: 'प्राथमिकताएं',
    integrations: 'एकीकरण',
    notifications: 'सूचनाएं',
    billing: 'बिलिंग',
    language: 'भाषा',
    needHelp: 'मदद चाहिए',
    reportsData: 'रिपोर्ट और डेटा',
    // Additional UI
    managePreferences: 'अपने खाते की प्राथमिकताएं प्रबंधित करें',
    manage: 'प्रबंधित करें',
    back: 'वापस',
    checkSeoHealth: 'अपने वेबसाइट के SEO स्वास्थ्य और प्रदर्शन को तुरंत जांचें।',
    enterWebsiteUrl: 'अपनी वेबसाइट का URL दर्ज करें...',
    performSeoCheck: 'SEO जांच करें',
    
    // Buttons
    save: 'सहेजें',
    cancel: 'रद्द करें',
    edit: 'संपादित करें',
    delete: 'हटाएं',
    add: 'जोड़ें',
    confirm: 'पुष्टि करें',
    submit: 'जमा करें',
    previous: 'पिछला',
    footer: 'फुटर',
    
    // Account Information Page
    manageSubscription: 'सदस्यता, बिलिंग और कनेक्टेड प्रोजेक्ट प्रबंधित करें',
    subscriptionBilling: 'सदस्यता और बिलिंग',
    currentPlan: 'वर्तमान योजना (लाइट / स्टैंडर्ड / एडवांस्ड)',
    renewalDateBillingCycle: 'नवीनीकरण तिथि और बिलिंग चक्र',
    billingHistory: 'बिलिंग इतिहास (चालान और रसीदें)',
    connectedWebsites: 'कनेक्टेड वेबसाइट / प्रोजेक्ट',
    linkedDomain: 'लिंक किया गया डोमेन / प्रोजेक्ट',
    projectStatus: 'प्रोजेक्ट स्थिति (सक्रिय / निष्क्रिय)',
    allRightsReserved: '© 2025 NovarsisAio — सर्वाधिकार सुरक्षित',
    accountInfo: 'खाता जानकारी',
  },
  arabic: {
    // Language Page
    selectLanguage: 'اختر لغتك',
    english: 'English',
    hindi: 'हिन्दी',
    arabic: 'العربية',
    
    // Common
    home: 'الرئيسية',
    aboutUs: 'من نحن',
    about: 'حول',
    contact: 'اتصل',
    contactUs: 'اتصل بنا',
    services: 'الخدمات',
    pricing: 'التسعير',
    dashboard: 'لوحة التحكم',
    settings: 'الإعدادات',
    profile: 'الملف الشخصي',
    logout: 'تسجيل الخروج',
    login: 'تسجيل الدخول',
    signIn: 'تسجيل الدخول',
    signup: 'إنشاء حساب',
    gallery: 'المعرض',
    faqs: 'الأسئلة الشائعة',
    forgotPassword: 'هل نسيت كلمة المرور؟',
    resetPassword: 'إعادة تعيين كلمة المرور',
    updatePassword: 'تحديث كلمة المرور',
    // Need / Help Center
    needHelp: 'هل تحتاج مساعدة؟',
    needHelpIntro: 'ابحث عن إجابات، اتصل بالدعم، أو اطلب خطة مخصصة.',
    contactSupport: 'اتصل بالدعم',
    contactSupportDesc: 'تواصل مع فريق الدعم للحصول على المساعدة التقنية.',
    guides: 'دروس وأدلة',
    guidesDesc: 'دروس خطوة بخطوة لمساعدتك على البدء.',
    feedback: 'التعليقات',
    feedbackDesc: 'شارك أفكارك وساعدنا على التحسين.',
    quickResources: 'موارد سريعة',
    gettingStarted: 'دليل البدء',
    seoChecklist: 'قائمة تحقق SEO',
    reportIssue: 'الإبلاغ عن مشكلة',
    messageSent: 'شكرًا - تم إرسال رسالتك!',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    message: 'الرسالة',
    supportPhone: '+1 (555) 123-4567',
    responseTime: 'الاستجابة النموذجية خلال 24 ساعة',
    
    // Dashboard
    welcome: 'مرحبًا',
    accountInfo: 'معلومات الحساب',
    preferences: 'التفضيلات',
    integrations: 'التكاملات',
    notifications: 'الإشعارات',
    billing: 'الفواتير',
    language: 'اللغة',
    needHelp: 'هل تحتاج مساعدة',
    reportsData: 'التقارير والبيانات',
    // Additional UI
    managePreferences: 'إدارة تفضيلات حسابك',
    manage: 'إدارة',
    back: 'رجوع',
    checkSeoHealth: 'تحقق من صحة وأداء SEO لموقعك على الويب على الفور.',
    enterWebsiteUrl: 'أدخل عنوان URL لموقعك...',
    performSeoCheck: 'إجراء فحص SEO',
    
    // Buttons
    save: 'حفظ',
    cancel: 'إلغاء',
    edit: 'تعديل',
    delete: 'حذف',
    add: 'إضافة',
    confirm: 'تأكيد',
    submit: 'إرسال',
    previous: 'السابق',
    footer: 'التذييل',
    
    // Account Information Page
    manageSubscription: 'إدارة الاشتراك والفواتير والمشاريع المتصلة',
    subscriptionBilling: 'الاشتراك والفواتير',
    currentPlan: 'الخطة الحالية (خفيفة / قياسية / متقدمة)',
    renewalDateBillingCycle: 'تاريخ التجديد ودورة الفوترة',
    billingHistory: 'سجل الفواتير (الفواتير والإيصالات)',
    connectedWebsites: 'المواقع / المشاريع المتصلة',
    linkedDomain: 'النطاق / المشاريع المرتبطة',
    projectStatus: 'حالة المشروع (نشط / غير نشط)',
    allRightsReserved: '© 2025 NovarsisAio — جميع الحقوق محفوظة',
    accountInfo: "معلومات الحساب"
  },
};

export const t = (key, language = 'english') => {
  return translations[language]?.[key] || key;
};
